<template>
  <div class="flex mb-8 pb-8 border-0 border-b border-solid border-grey-200 last:mb-0 last:border-b-0">
    <AvatarPlaceholder
      :config="props.review.profilePicturePlaceholderConfig"
      :initials="props.review.initials"
      size="small"
    />

    <div class="w-full mx-3" style="max-width: calc(100% - 90px);">
      <div class="text-sm flex items-center leading-5">
        {{ props.review.author }}

        <div class="text-green ml-2 flex items-center text-xs shrink-0 leading-5">
          <VerifiedIcon class="w-3 h-3 mr-1" />

          Verified review
        </div>
      </div>

      <div class="mt-1.5 font-semibold">
        <CommunicationScore v-if="props.review.isCommunicationReview" :score="props.review.score" />
        <template v-else>
          {{ review.roomTag }} · {{ review.people }} {{ review.people > 1 ? 'guests' : 'guest' }}
          <template v-if="review.eventDateFormatted">
            · {{ review.eventDateFormatted }}
          </template>
        </template>
      </div>

      <div v-if="props.review.positives" class="mt-6 text-tiny leading-5 break-words">
        <PlusIcon class="inline-block w-5 h-5 text-green relative top-1" />
        {{ props.review.positives }}
      </div>

      <div v-if="props.review.negatives" class="mt-6 text-tiny leading-5 break-words">
        <MinusIcon class="inline-block w-5 h-5 text-grey relative top-1" />
        {{ props.review.negatives }}
      </div>

      <div v-if="props.review.opinion" class="mt-6 text-tiny leading-5 break-words">
        {{ props.review.opinion }}
      </div>

      <ReviewsRowImages v-if="props.review.photos?.length > 0" class="mt-6" :photos="props.review.photos" @track="emit('track', $event)" />
      <Tooltip
        position="top-left"
        mobile-position="top-left"
        :text="`Submitted: ${props.review.reviewDateLong}`"
      >
        <div v-if="props.review.reviewedTimeAgoText" class="text-grey-600 mt-4 cursor-default">
          Submitted {{ props.review.reviewedTimeAgoText }} ago
        </div>
      </Tooltip>
    </div>

    <div class="flex-shrink-0">
      <div class="bg-green rounded-lg rounded-bl-none px-1 py-1.5 text-init font-semibold text-white">
        {{ formatNumber(props.review.score) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import VerifiedIcon from '@tagvenue/icons/24/bold/general/check-verified-02.svg';
import MinusIcon from '@tagvenue/icons/24/bold/general/minus-square.svg';
import PlusIcon from '@tagvenue/icons/24/bold/general/plus-square.svg';
import { defineEmits, defineProps } from 'vue';

import AvatarPlaceholder from '@/components/Ui/AvatarPlaceholder.vue';
import Tooltip from '@/components/Ui/Tooltip.vue';

import CommunicationScore from './CommunicationScore.vue';
import ReviewsRowImages from './ReviewsRowImages.vue';

const emit = defineEmits(['track']);

const props = defineProps({
  review: {
    type: Object,
    default: () => ({}),
  },
});

const formatNumber = (number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(number);
};
</script>
